import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { motion } from "framer-motion";

const API_URL = "https://backend.aktcorp.com/media";

export const DeleteNews = () => {
  const [news, setNews] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPage, setShowPage] = useState(false);

  const token = localStorage.getItem("authToken");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`, // ✅ JWT token header
  };

  useEffect(() => {
    fetchNews();
  }, []);

  useEffect(() => {
    // Show animation for 3 seconds before loading the page content
    const timer = setTimeout(() => {
      setShowPage(true);
      fetchNews();
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  

  const fetchNews = async () => {
    try {
      const response = await axios.get(API_URL);
      setNews(response.data.data);
    } catch (error) {
      console.error("Error fetching news:", error);
    }
  };

  const handleDelete = async (id) => {
    setLoading(true);

    // Show animation for 3 seconds before actual delete
    setTimeout(async () => {
      try {
        await axios.delete(`${API_URL}/${id}`, { headers });
        setNews((prevNews) => prevNews.filter((item) => item.id !== id)); // Update UI
      } catch (error) {
        console.error("Error deleting news:", error);
      }

      setLoading(false);
      setDeleteId(null); // Close modal
    }, 3000);
  };

  if (!showPage) {
    return (
      <div className="flex items-center justify-center">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
          className="w-24 h-24 border-4 border-t-transparent border-blue-600 rounded-full mx-auto mt-32"
        ></motion.div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg mb-10">
      <motion.h2
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-3xl font-bold text-gray-900 bg-clip-text text-center mb-4 text-transparent bg-gradient-to-r from-blue-500 to-purple-500"
      >
        Delete Media
      </motion.h2>

      <ul>
        {news.map((item) => (
          <li key={item.id} className="border-b py-3 flex justify-between items-center">
            <div className="flex justify-center">
              {item.image && <img src={item.image} alt="News" className="w-14 h-14 object-cover mr-6 rounded-lg" />}
              <div className="max-w-3xl">
                <h3 className="text-lg font-semibold">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            </div>
            <button
              onClick={() => setDeleteId(item.id)}
              className="text-red-500 text-lg font-semibold mt-3"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </li>
        ))}
      </ul>

      {/* Delete Confirmation Modal */}
      {deleteId && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
            className="bg-white p-6 rounded-lg shadow-lg max-w-xs w-full text-center"
          >
            <h2 className="text-xl font-bold mb-2 text-red-600">DELETE?</h2>
            <p className="text-red-600 mb-3">Are you sure you want to delete this news?</p>

            <div className="flex justify-between">
              {/* Show Animation after Clicking */}
              {loading ? (
                <motion.div
                  animate={{ rotate: 360 }}
                  transition={{ repeat: Infinity, duration: 0.8, ease: "linear" }}
                  className="w-6 h-6 border-4 border-red-500 border-t-transparent rounded-full mx-auto"
                ></motion.div>
              ) : (
                <div className="flex gap-32 text-center justify-center">
                  <button
                    onClick={() => handleDelete(deleteId)}
                    className="bg-red-500 text-white px-6 py-2 rounded-md"
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => setDeleteId(null)}
                    className="bg-gray-500 text-white px-6 py-2 rounded-md"
                    disabled={loading}
                  >
                    No
                  </button>
                </div>
              )}


            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default DeleteNews;
